// actions
import {
    GET_TAB_REDIRECT,
    SET_TAB_REDIRECT,
    GET_HAS_MULTI_DATES,
    SET_HAS_MULTI_DATES,
    GET_START_CHART_DATE,
    SET_START_CHART_DATE,
    GET_END_CHART_DATE,
    SET_END_CHART_DATE,
    SUBMIT_DATA_REQUEST,
    GET_SUBSCRIBE_KEY,
    GET_ALT_DATE_RANGE,
    SET_ALT_DATE_RANGE,
    GET_MULTI_DATES,
    GET_MULTI_DATES_ONLY,
    ADD_MULTI_DATES,
    REMOVE_MULTI_DATES,
    MODIFY_MULTI_DATE,
    GET_TAB_TITLE,
    SET_TAB_TITLE,
    RESET_SENSORS_STATE,
    GET_INIT_QUERY_DONE,
    SET_INIT_QUERY_DONE,
    RESTORE_MULTI_DATE,
    SET_GRID_VIEW,
    GET_GRID_VIEW
} from '../actions/sensors';
// utils
import {
    formatShortDate,
    generateAutoMultiDates,
    getPastDate,
    setHoursHelper
} from "../../utils/common";
// constants
import {maximumDatesInclinometers} from "../../constants/chart-constants";
import {sensorsTableMap} from "../../constants/sensors-constants";

const getDefaultState = () => {
    return {
        activeTab: sensorsTableMap.controller,
        tabRedirect: false,
        hasMultiDates: false,
        dateRange: {
            1: {                                   // controller
                start: getPastDate(3),      // current midnight
                end: setHoursHelper(24)      // next day midnight
            },
            2: {                                   // piezometers
                start: getPastDate(3),
                end: setHoursHelper(24)
            },
            3: {                                   // inclinometers (not really used)
                start: getPastDate(3),
                end: setHoursHelper(24)
            },
            4: {                                   // levelmeter
                start: getPastDate(3),
                end: setHoursHelper(24)
            },
            6: {                                   // levelmeter
                start: getPastDate(3),
                end: setHoursHelper(24)
            }
        },
        submitSubscribeKey: 0,                 // on submit, iterate to trigger chart data query via subscribe,
        alternativeDateRange: formatShortDate(),
        multiDates: generateAutoMultiDates(),
        tabTitle: "sensors-page.tab-title-generic",  // default,
        isInitialQuery: true,
        internalCounterQuery: 0,
        gridView: 2
    }
};

const state = getDefaultState();

const getters = {
    [GET_TAB_REDIRECT]: state => state.tabRedirect,
    [GET_HAS_MULTI_DATES]: state => state.hasMultiDates,
    [GET_START_CHART_DATE]: state => state.dateRange[state.activeTab].start,
    [GET_END_CHART_DATE]: state => state.dateRange[state.activeTab].end,
    [GET_SUBSCRIBE_KEY]: state => state.submitSubscribeKey,
    [GET_ALT_DATE_RANGE]: state => state.alternativeDateRange,
    [GET_MULTI_DATES]: state => state.multiDates,
    [GET_TAB_TITLE]: state => state.tabTitle,
    [GET_MULTI_DATES_ONLY]: state => state.multiDates.map((item) => item.date),
    [GET_INIT_QUERY_DONE]: state => state.isInitialQuery,
    [GET_GRID_VIEW]: state => state.gridView
};

const actions = {
    [SET_TAB_REDIRECT]: ({commit}, doRedirect) => commit(SET_TAB_REDIRECT, doRedirect),
    [SET_HAS_MULTI_DATES]: ({commit}, hasMultiDatesBool) => commit(SET_HAS_MULTI_DATES, hasMultiDatesBool),
    [SET_START_CHART_DATE]: ({commit}, payload) => commit(SET_START_CHART_DATE, payload),
    [SET_END_CHART_DATE]: ({commit}, payload) => commit(SET_END_CHART_DATE, payload),
    [SUBMIT_DATA_REQUEST]: ({commit}) => commit(SUBMIT_DATA_REQUEST),
    [SET_ALT_DATE_RANGE]: ({commit}, alternativeDateRange) => commit(SET_ALT_DATE_RANGE, alternativeDateRange),
    [ADD_MULTI_DATES]: ({commit}, newMultiDate) => commit(ADD_MULTI_DATES, newMultiDate),
    [REMOVE_MULTI_DATES]: ({commit}, index) => commit(REMOVE_MULTI_DATES, index),
    [MODIFY_MULTI_DATE]: ({commit}, index) => commit(MODIFY_MULTI_DATE, index),
    [RESTORE_MULTI_DATE]: ({commit}, index) => commit(RESTORE_MULTI_DATE, index),
    [SET_TAB_TITLE]: ({commit}, newTitle) => commit(SET_TAB_TITLE, newTitle),
    [RESET_SENSORS_STATE]: ({commit}) => commit(RESET_SENSORS_STATE),
    [SET_INIT_QUERY_DONE]: ({ commit }) => commit(SET_INIT_QUERY_DONE),
    [SET_GRID_VIEW]: ({commit}, activeView ) => commit(SET_GRID_VIEW, activeView)
};

const mutations = {
    [SET_TAB_REDIRECT]: (state, doRedirect) => {
        state.tabRedirect = doRedirect;
    },
    [SET_HAS_MULTI_DATES]: (state, hasMultiDatesBool) => {
        state.hasMultiDates = hasMultiDatesBool;
    },
    [SET_START_CHART_DATE]: (state, payload) => {
        state.dateRange[payload.activeTab].start = payload.startDate;
    },
    [SET_END_CHART_DATE]: (state, payload) => {
        state.dateRange[payload.activeTab].end = payload.endDate;
    },
    [SUBMIT_DATA_REQUEST]: (state) => {
        state.submitSubscribeKey++;
    },
    [SET_ALT_DATE_RANGE]: (state, alternativeDateRange) => {
        state.alternativeDateRange = alternativeDateRange;
    },
    [ADD_MULTI_DATES]: (state, newMultiDate) => {
        const datesOnly = state.multiDates.map((item) => item.date);

        if (!datesOnly.includes(newMultiDate) &&
            state.multiDates.length < maximumDatesInclinometers) {
            state.multiDates.push({date: newMultiDate, hasSeries: true});

            state.multiDates = state.multiDates.sort((a, b) => (a.date > b.date) ? 1 : -1);
        }
    },
    [REMOVE_MULTI_DATES]: (state, index) => {
        state.multiDates.splice(index, 1);
    },
    [MODIFY_MULTI_DATE]: (state, index) => {
        state.multiDates[index].hasSeries = false;
    },
    [RESTORE_MULTI_DATE]: (state, index) => {
        state.multiDates[index].hasSeries = true;
    },
    [SET_TAB_TITLE]: (state, newTitle) => {
        state.tabTitle = newTitle;
    },
    [RESET_SENSORS_STATE]: (state) => {
        Object.assign(state, getDefaultState());
    },
    [SET_INIT_QUERY_DONE]: (state) => {
        // both profiles should have init query set to true the first time
        state.internalCounterQuery++;
        if (state.internalCounterQuery === 2) {
            state.isInitialQuery = false;
        }

    },
    [SET_GRID_VIEW]: (state, activeView) => {
        state.gridView = activeView;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};

